(() => {
  const THRESHOLD = 15000;
  const GIFT_VARIANT_ID = 40955008647361;
  const GIFT_PROPERTY = '_branche_complimentary_gift';
  const nativeFetch = window.fetch.bind(window);

  let syncing = false;
  let timer = null;

  const money = (cents, currency = 'USD') => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(0);
    }
  };

  const isTaggedGift = (item) => {
    return item.properties &&
      String(item.properties[GIFT_PROPERTY]) === 'true';
  };

  const isCurrentGift = (item) => {
    return isTaggedGift(item) && Number(item.variant_id) === GIFT_VARIANT_ID;
  };

  const qualifyingTotal = (cart) => {
    return cart.items.reduce((total, item) => {
      if (isTaggedGift(item)) return total;
      return total + Number(item.final_line_price || 0);
    }, 0);
  };

  const updateProgress = (cart) => {
    const total = qualifyingTotal(cart);
    const remaining = Math.max(0, THRESHOLD - total);
    const percent = Math.min(100, Math.max(0, (total / THRESHOLD) * 100));

    document.querySelectorAll('[data-branche-gift-progress]').forEach((bar) => {
      const message = bar.querySelector('[data-branche-gift-message]');
      const fill = bar.querySelector('[data-branche-gift-fill]');
      const progress = bar.querySelector('[role="progressbar"]');

      if (message) {
        const nextMessage = total >= THRESHOLD
          ? 'Your complimentary CHOUCHOU - Black Large is unlocked.'
          : `You're ${money(remaining, cart.currency)} away from a complimentary CHOUCHOU - Black Large.`;

        if (message.textContent.trim() !== nextMessage) {
          message.textContent = nextMessage;
        }
      }

      if (fill) fill.style.width = percent + '%';

      if (progress) {
        progress.setAttribute('aria-valuenow', String(Math.floor(total / 100)));
      }
    });
  };

  const getCart = async () => {
    const response = await nativeFetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  };

  const addGift = async () => {
    const response = await nativeFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: {
            [GIFT_PROPERTY]: 'true',
            'Complimentary Gift': 'Spend $150'
          }
        }]
      })
    });

    if (!response.ok) throw new Error('Unable to add complimentary gift');
  };

  const removeGift = async (itemKey) => {
    const response = await nativeFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    });

    if (!response.ok) throw new Error('Unable to remove complimentary gift');
  };

  const announceCartChange = (cart) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'branche:complimentary-gift',
        cart
      }
    }));
  };

  const syncGift = async () => {
    if (syncing) return;
    syncing = true;

    try {
      let cart = await getCart();
      updateProgress(cart);

      const total = qualifyingTotal(cart);
      const taggedGifts = cart.items.filter(isTaggedGift);
      const wrongGift = taggedGifts.find((item) => !isCurrentGift(item));
      let currentGift = taggedGifts.find(isCurrentGift);

      if (wrongGift) {
        await removeGift(wrongGift.key);
        cart = await getCart();
        updateProgress(cart);
        currentGift = cart.items.find(isCurrentGift);
      }

      if (total >= THRESHOLD && !currentGift) {
        await addGift();
        cart = await getCart();
        updateProgress(cart);
        announceCartChange(cart);
      } else if (total < THRESHOLD && currentGift) {
        await removeGift(currentGift.key);
        cart = await getCart();
        updateProgress(cart);
        announceCartChange(cart);
      } else if (wrongGift) {
        announceCartChange(cart);
      }
    } catch (error) {
      console.warn('[Branché complimentary gift]', error);
    } finally {
      syncing = false;
    }
  };

  const scheduleSync = (delay = 180) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncGift, delay);
  };

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);

    try {
      const request = args[0];
      const url = typeof request === 'string'
        ? request
        : request && request.url
          ? request.url
          : '';

      if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) {
        scheduleSync();
      }
    } catch (error) {}

    return response;
  };

  document.documentElement.addEventListener('cart:change', (event) => {
    const cart = event.detail && event.detail.cart;
    if (cart) updateProgress(cart);

    if (!event.detail || event.detail.baseEvent !== 'branche:complimentary-gift') {
      scheduleSync(120);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleSync(0), { once: true });
  } else {
    scheduleSync(0);
  }

  window.addEventListener('pageshow', () => scheduleSync(0));
})();